import React, { useRef, useEffect } from 'react';
import { Formik, Field } from 'formik';
import { Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import { usePincodeLookup } from '../../hooks/usePincodeLookup';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';


import { updateFieldOfficerInfo } from '../../store/features/fieldOfficerInfo';
import { schema } from './updateFieldOfficerSchema';

const UpdateFieldOfficerProfile = ({ userData }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const formApiRef = useRef({});
  const { pincodeData, loading: pincodeLoading, lookupPincode, reset: resetPincode } = usePincodeLookup();

  const { foUpdateStatus } = useSelector(
    (state) => state.fieldOfficerInfo
  );

  useEffect(() => {
    if (!pincodeData || !formApiRef.current.setFieldValue) return;
    const { setFieldValue } = formApiRef.current;

    setFieldValue('state', pincodeData.state);
    setFieldValue('city', pincodeData.district);
  }, [pincodeData]);

  let initialMobile = userData.mobile_no || '';
  if (initialMobile && !initialMobile.startsWith('+') && initialMobile.length === 10) {
    initialMobile = '+91' + initialMobile;
  }

  return (
    <Formik
      initialValues={{
        name: userData.name || '',
        mobile_no: initialMobile,
        email_id: userData.email_id || '',
        address: userData.address || '',
        pincode: userData.pincode || '',
        state: userData.state || '',
        city: userData.city || '',
      }}
      validationSchema={schema}
      onSubmit={(values) => {
        let formattedMobile = values.mobile_no;
        if (formattedMobile && formattedMobile.startsWith('+91')) {
          formattedMobile = formattedMobile.replace('+91', '');
        }

        const payload = {
          ...values,
          mobile_no: formattedMobile
        };

        dispatch(updateFieldOfficerInfo({ id, values: payload }));
      }}
    >
      {({ handleSubmit, setFieldValue, setFieldTouched, handleChange, errors, touched, values }) => {
        formApiRef.current = { setFieldValue };
        return (
        <Form onSubmit={handleSubmit}>
          <Row className="g-3 mt-3">

            <Col md={12}>
              <Field
                name="name"
                placeholder="Name"
                className={`form-control ${errors.name && touched.name ? 'border-danger' : ''}`}
              />
              {errors.name && touched.name && <div className="text-danger small mt-1">{errors.name}</div>}
            </Col>

            <Col md={12}>
              <Field name="mobile_no">
                {({ field, form }) => (
                  <PhoneInput
                    international
                    defaultCountry="IN"
                    placeholder="Mobile"
                    value={field.value}
                    onChange={(val) => {
                      form.setFieldValue(field.name, val);
                      form.setFieldTouched(field.name, true, false);
                    }}
                    onBlur={() => form.setFieldTouched(field.name, true)}
                    className={`form-control d-flex align-items-center ${
                      errors.mobile_no && touched.mobile_no ? 'border-danger' : ''
                    }`}
                  />
                )}
              </Field>
              {errors.mobile_no && touched.mobile_no && <div className="text-danger small mt-1">{errors.mobile_no}</div>}
            </Col>

            <Col md={12}>
              <Field
                name="email_id"
                placeholder="Email"
                className={`form-control ${errors.email_id && touched.email_id ? 'border-danger' : ''}`}
              />
              {errors.email_id && touched.email_id && <div className="text-danger small mt-1">{errors.email_id}</div>}
            </Col>

            <Col md={12}>
              <Field
                name="address"
                placeholder="Address"
                className={`form-control ${errors.address && touched.address ? 'border-danger' : ''}`}
              />
              {errors.address && touched.address && <div className="text-danger small mt-1">{errors.address}</div>}
            </Col>

            <Col md={12}>
              <Field
                name="pincode"
                placeholder="Zip / Postal Code"
                className={`form-control ${errors.pincode && touched.pincode ? 'border-danger' : ''}`}
                onBlur={(e) => {
                  setFieldTouched('pincode', true);
                  const val = String(e.target.value).trim();
                  if (val.length === 6 && /^\d+$/.test(val)) lookupPincode(val);
                }}
                onChange={(e) => {
                  handleChange(e);
                  if (String(e.target.value).length !== 6) resetPincode();
                }}
              />
              {pincodeLoading && <small className="text-muted">Looking up address...</small>}
              {errors.pincode && touched.pincode && <div className="text-danger small mt-1">{errors.pincode}</div>}
            </Col>

            {pincodeData?.addressSuggestions?.length > 0 && (
              <Col md={12}>
                <label className="form-label small text-muted">Suggested addresses (select to auto-fill)</label>
                <Select
                  isClearable
                  isSearchable
                  placeholder="Select address suggestion"
                  options={pincodeData.addressSuggestions}
                  onChange={(opt) => opt && setFieldValue('address', opt.value)}
                />
              </Col>
            )}

            <Col md={12}>
              <Field
                name="state"
                placeholder="State"
                className={`form-control ${errors.state && touched.state ? 'border-danger' : ''}`}
              />
              {errors.state && touched.state && <div className="text-danger small mt-1">{errors.state}</div>}
            </Col>

            <Col md={12}>
              <Field
                name="city"
                placeholder="City"
                className={`form-control ${errors.city && touched.city ? 'border-danger' : ''}`}
              />
              {errors.city && touched.city && <div className="text-danger small mt-1">{errors.city}</div>}
            </Col>

            <Col md={12}>
              <button
                type="submit"
                className="btn btn-dark w-100 mt-2"
                disabled={foUpdateStatus === 'loading'}
              >
                {foUpdateStatus === 'loading'
                  ? 'Updating...'
                  : 'Update'}
              </button>
            </Col>
          </Row>
        </Form>
        );
      }}
    </Formik>
  );
};

export default UpdateFieldOfficerProfile;